import EmptyContent from '@/commons/empty-content/EmptyContent';
import Loader from '@/commons/loader';
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { getMethodsFactureService } from '@/services';
import { currentFormat } from '@/utils/cases';
import { translates } from '@/utils/translate';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from '@mui/lab';
import { Box, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export default function LogsPaymentMethodTimeLine({ id }: any) {
  const { fetchId, data, isLoading } = useFetch({
    fetchFunction: getMethodsFactureService,
    getData: true,
  });

  const handleGetMethodsFacture = async () => {
    await fetchId(id);
  };

  useEffect(() => {
    handleGetMethodsFacture();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  if (isLoading) {
    return <Loader />;
  }
  if (!data?.length) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <EmptyContent
          title={translates.noData}
          sx={{
            '& span.MuiBox-root': { height: 160 },
          }}
        />
      </Stack>
    );
  }
  return (
    <Timeline
      placeholder=""
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
      sx={{
        p: 0,
        m: 0,
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 2,
        },
      }}
    >
      {data.map((item: any) => {
        const { comment, created_at: createdAt, responsibleName, newPayment, lastPayment } = item;

        return (
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot variant="filled" color="info" />
              <TimelineConnector />
            </TimelineSeparator>

            <TimelineContent>
              <Typography variant="subtitle2">Folio: {item?._id.slice(0, 7)}</Typography>
              <Typography variant="subtitle2">Orden: {item?.factureId.slice(0, 7)}</Typography>
              <Stack direction="row" spacing={1}>
                <Stack spacing={0.5}>
                  <Typography variant="subtitle1">Monto Anterior</Typography>
                  <Typography variant="caption">
                    {translates.cash}: <strong>{currentFormat(lastPayment?.cash ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    {translates.creditCard}:{' '}
                    <strong>{currentFormat(lastPayment?.creditCard ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    {translates.transference}:{' '}
                    <strong>{currentFormat(lastPayment?.transference ?? 0)}</strong>
                  </Typography>
                </Stack>
                <Stack spacing={0.5}>
                  <Typography variant="subtitle1">Monto Nuevo</Typography>

                  <Typography variant="caption">
                    {translates.cash}: <strong>{currentFormat(newPayment?.cash ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    {translates.creditCard}:{' '}
                    <strong>{currentFormat(newPayment?.creditCard ?? 0)}</strong>
                  </Typography>
                  <Typography variant="caption">
                    {translates.transference}:{' '}
                    <strong>{currentFormat(newPayment?.transference ?? 0)}</strong>
                  </Typography>
                </Stack>
              </Stack>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>{comment}</Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {dayjs(createdAt).format('DD/MM/YY hh:mm A')}
              </Box>
              <Box sx={{ color: 'text.disabled', typography: 'caption', mt: 0.5 }}>
                {responsibleName?.name}
              </Box>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
}
